var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcProfileBuggy = function SvgIcProfileBuggy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    fill: "none",
    viewBox: "0 0 18.937 21.684"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#DEDEE3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.937,
    d: "M5.47 21.215a1.76 1.76 0 0 0 1.62-2.473l1.413-1.412a.913.913 0 0 0 0-1.291L7.09 14.626a.92.92 0 0 0-.995-.199.9.9 0 0 0-.296.199l-2.435 2.436a1.947 1.947 0 0 0 0 2.758l.864.865a1.76 1.76 0 0 0 1.243.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.937,
    d: "M13.293 21.215c.342.001.678-.087.975-.256l1.06-.609a1.772 1.772 0 0 0-.89-3.306h-.11a9 9 0 1 0-3.8 1.364l1.066 1.827a1.95 1.95 0 0 0 1.7.98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEE3",
    strokeWidth: 0.621,
    d: "M14.424 9.099a.51.51 0 1 1 0-1.02.51.51 0 0 1 0 1.02ZM10.695 9.099a.51.51 0 1 1 0-1.02.51.51 0 0 1 0 1.02Z"
  }))));
};
export default SvgIcProfileBuggy;